var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _vm.OnlineOnly
      ? _c("div", { staticClass: "row" }, [
          _c("i", { staticClass: "material-icons icon" }, [_vm._v("error")]),
          _vm._v(" "),
          _c("span", [
            _vm._v("An error occured while loading the component. ")
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "link", on: { click: _vm.reload } }, [
              _vm._v("Try again")
            ]),
            _vm._v(" /\n      "),
            _c("span", { staticClass: "link", on: { click: _vm.close } }, [
              _vm._v(" Close")
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.OfflineOnly
      ? _c("div", { staticClass: "row" }, [
          _c("i", { staticClass: "material-icons icon" }, [_vm._v("error")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "Component couldn't be loaded due to lack of network connectivity."
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "link", on: { click: _vm.close } }, [
            _vm._v("Close")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }